export const initialFormValues = {
  accountDescription: '',
  accountNumber: '',
  accountDescriptionText: '',
  additionalDepreciationValue: '',
  observations: ''
}
